<script setup>
import { ref } from "vue";
// import { useElementVisibility } from "@vueuse/core";
import clientConfig from "/src/config/client";
import FooterSection from "./FooterSection.vue";
import DropdownMenu from "./DropdownMenu.vue";

import { onMounted } from "vue";
import AOS from "aos";

onMounted(() => {
  AOS.init();
});

// const videoPlaying = ref(false);
const showModal = ref(false);
const productList = ref(clientConfig.content.products);
const products = ref(null);
// const scrolledToProducts = useElementVisibility(products);
const homepageHeroVideo = ref(null);

function startVideo() {
  if (homepageHeroVideo.value) {
    homepageHeroVideo.value.play();
  }
}

function stopVideo() {
  if (homepageHeroVideo.value) {
    homepageHeroVideo.value.pause();
    homepageHeroVideo.value.currentTime = 0;
  }
}
</script>

<template>
  <!-- ======= Hero Section ======= -->
  <section id="hero" class="home" ref="home">
    <DropdownMenu />
    <div class="container">
      <div class="row">
        <div
          class="col-lg-8 order-1 order-lg-1 hero-img pl-5"
          data-aos="zoom-in"
          data-aos-delay="200"
        >
          <div class="pen_logo"></div>
          <h2>
            Insurance that <br /><span class="cursive">Evolves </span>with you
          </h2>
          <h3 class="highlight">
            Partnering with you to deliver innovative insurance solutions
          </h3>
        </div>
        <div
          class="col-lg-4 flex-column justify-content-top pt-4 pt-lg-0 order-2 order-lg-2 mt-5 d-flex gap-4 mx-auto"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          <button
            class="quick-link scrollto"
            @click="
              showModal = true;
              startVideo();
            "
          >
            <h4>Who we are</h4>
            <p>► Play Video</p>
          </button>
          <!-- Button trigger modal -->
          <!-- <router-link
            to="/#products"
            class="quick-link scrollto"
            :class="scrolledToProducts ? 'active' : ''"
          >
            <h4>Products & Services</h4>
            <p>We help you grow your business</p>
          </router-link> -->
          <a
            class="quick-link scrollto"
            href="brochure/pen-on-a-page.pdf"
            target="_blank"
          >
            <h4>Pen on a Page</h4>
            <p>We help you grow your business</p>
          </a>
          <router-link to="/team" class="quick-link scrollto">
            <h4>The Team</h4>
            <p>Our people are our strength</p>
          </router-link>
          <router-link to="/recent-wins" class="quick-link scrollto">
            <h4>Recent Wins</h4>
            <p>See what we’ve been up to</p>
          </router-link>
        </div>
      </div>
    </div>
  </section>
  <!-- End Hero -->
  <main id="">
    <!-- ======= About Us Section ======= -->
    <section id="about" class="about">
      <div class="container" data-aos="fade-left">
        <div class="row actions">
          <div class="col text-center">
            <span class="cursive">Protecting</span> Businesses
          </div>
          <span class="d-none d-sm-block">|</span>
          <div class="col text-center">
            Growth by <span class="cursive">Partnerships</span>
          </div>
          <span class="d-none d-sm-block">|</span>
          <div class="col text-center">
            Innovative <span class="cursive">Solutions</span>
          </div>
        </div>

        <!-- <div class="side-banner">
          <p>The Power of Pen:</p>
          <h2>Giving you<br />the <span class="cursive">Edge</span></h2>
        </div>

        <Carousel>
          <Slide v-for="slide in slides" :key="slide.id">
            <div class="carousel__item">
              <div class="row content px-5">
                <div class="col-lg-4">
                  <img
                    :src="require(`@/assets/img/${slide.imageUrl}.png`)"
                    alt=""
                  />
                </div>
                <div class="col-lg-4 title">
                  <h3 class="highlight mb-0">{{ slide.title }}</h3>
                  <h3>{{ slide.subheading }}</h3>
                  <p class="mb-0">LOREM IPSUM DOLOR AMET CONSECTETUER</p>
                  <a href="">Meet the team</a>
                </div>
                <div class="col-lg-4 content">
                  <p>{{ slide.content }}</p>
                </div>
              </div>
            </div>
          </Slide>

          <template #addons>
            <Navigation />
          </template>
        </Carousel> -->
      </div>
    </section>
    <!-- End About Us Section -->

    <!-- ======= Products & Services Section ======= -->
    <section id="products" class="section products" ref="products">
      <div class="container text-center" data-aos="zoom-in">
        <h3 class="highlight text-center">Products & Services</h3>
        <div class="row xs-justify-content-center g-3 product-wrapper">
          <div
            class="col-5 col-md-4"
            v-for="product in productList"
            :key="product.id"
          >
            <div class="card">
              <a class="card-body" :href="`#${product.clickUrl}`">
                <img
                  :src="require(`@/assets/img/pen/${product.imageUrl}.png`)"
                  alt=""
                />
                <h4 class="card-title mt-4 highlight">{{ product.title }}</h4>
              </a>
            </div>
          </div>
        </div>
        <!-- <router-link to="/products-and-services" class="highlight">
          <button>Explore more</button>
        </router-link> -->
        <!-- <section>
          <div class="text-center">
            <a
              class="btn btn-outline inverse"
              href="brochure/pen-on-a-page.pdf"
              target="_blank"
            >
              Pen on a Page
            </a>
          </div>
        </section> -->
      </div>
    </section>
    <!-- End Superscore Section -->
  </main>
  <!-- End #main -->

  <FooterSection />

  <a href="#" class="back-to-top"><i class="ri-arrow-up-line"></i></a>
  <!-- <div id="preloader"></div> -->
  <!-- ======= Modal ======= -->
  <div
    class="modal animate__animated animate__fadeIn"
    :class="showModal ? 'show' : ''"
    id="videoModal"
    tabindex="-1"
    aria-labelledby="videoModalLabel"
    :aria-hidden="showModal ? 'false' : 'true'"
    aria-modal="true"
    role="dialog"
    :style="showModal ? 'display:block' : ''"
  >
    <div class="modal-dialog modal-lg video">
      <div class="modal-content">
        <button
          type="button"
          class="btn-close video"
          data-bs-dismiss="modal"
          aria-label="Close"
          @click="
            showModal = false;
            stopVideo();
          "
        ></button>
        <div class="modal-body">
          <!-- <div class="modal-copy"> -->
          <video
            id="homepage-video"
            ref="homepageHeroVideo"
            class="background-video-hosted html5-video d-block mb-4 mx-auto"
            controls
            src="@/assets/video/Pen_Underwriting-Generic_Version_SD.mp4"
            poster="@/assets/video/pen-generic-video-poster.jpg"
            width="100%"
            height="100%"
          ></video>
        </div>
      </div>
    </div>
  </div>
  <!-- End Modal -->
  <div :class="showModal ? 'modal-backdrop show' : ''"></div>
</template>
